<template>
    <div id="test" class="drawer-container" @click.prevent.stop="$emit('close-drawer')">
        <div class="drawer">
            <p>Text</p>
            <p>Link</p>
            <p>Go Back</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Drawer"
    }
</script>

<style scoped>
    .drawer-container{
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .drawer{
        position: absolute;
        width: 80vw;
        height: 80vh;
        border-radius: 10px;
        background-color: white;
        box-shadow: 0 0 8px 1px rgba(150, 150, 150, 1);
        top: 5vh;
        left: 10vw;
    }

</style>